module.exports = __webpack_public_path__ + "images/blue_bg-c3cf0901b2.png";